import React from "react";
import ReuseModal from "../../../../../components/fragment/modal/ReuseModal";
import { myComponentProps } from "./EndSessionModal";
import { RazorInputField } from "../../../../../components/razor-reuse";
import styles from "../../../../../styles/dashboard/setting/modals/EnableMFAPassword.module.css";

interface enableMFAModal extends myComponentProps {
  onSuccess: () => void;
}

export default function EnableMFAPassword({
  onClose,
  visible,
  onSuccess,
}: enableMFAModal) {
  const [password, setPassword] = React.useState(""); // Current Password

  // Submit Password to get QR
  const handleSubmit = async (e?: any) => {
    e && e.preventDefault();
    onClose && onClose();
    onSuccess();
  };

  return (
    <>
      <ReuseModal
        visible={visible}
        onClose={onClose}
        hideCancel
        onBtnClick={handleSubmit}
        btnLabel="Continue"
        title="Enable 2FA"
      >
        <form
          style={{ width: "100%" }}
          onSubmit={handleSubmit}
          autoComplete="off"
        >
          <>
            <p className={styles.deleteText}>
              Before you activate two factor authentication, verify your
              account.
            </p>
          </>
          <RazorInputField
            color="black-light"
            type="password"
            label="Current Password"
            placeholder="Enter Password"
            value={password}
            name="current_password"
            onChange={(e: any) => {
              setPassword(e.target.value);
            }}
          />
        </form>
      </ReuseModal>
    </>
  );
}
